import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	placeholderNonFinal: {
		id: 'polaris-ideas.view-content.idea-list.row.inline-issue-create.placeholder-non-final',
		defaultMessage: 'Add a quick summary and press enter',
		description: 'Placeholder message visible when creating an issue in list view.',
	},
});
